import slugify from 'slugify';
import { slugifyConfig } from './constants';

export function customSlugify(string) {
  return slugify(string, slugifyConfig);
}
